<template>
  <div>
    <div class="flex  relative shadow z-10" @click="toggle()">
      <div class="flex-1 p-3">{{outerlabel}}</div>
      <svg v-show="!isOpen && enabled" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"><g transform="translate(808.266 -630.592) rotate(90)"><path d="M662.04,783.942l-14.446-11.257a1.615,1.615,0,0,0-1-.355,1.935,1.935,0,0,0-1.785,2.053V796.9a1.935,1.935,0,0,0,1.785,2.053h0a1.609,1.609,0,0,0,1-.355l14.446-11.256a2.232,2.232,0,0,0,0-3.4Zm-.667,2.264-14.445,11.256a.527.527,0,0,1-.329.12.645.645,0,0,1-.6-.686V774.383a.645.645,0,0,1,.6-.686.528.528,0,0,1,.33.12l14.445,11.257a.743.743,0,0,1,0,1.132Z"/></g></svg>
    </div>
    <div class="relative z-20" v-if="enabled">
      <div class="overflow-hidden shadow-lg w-full h-0 absolute transition-all duration-150 bg-card" ref="container">
        <div class="absolute w-full" ref="content">
          <div class="p-2 px-3 text-sm text-secondary_text" v-if="innerlabel">
            {{innerlabel}}
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    outerlabel: String,
    innerlabel: String,
    enabled: Boolean
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    toggle() {
      if(this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    },
    open() {
      if(this.$refs.container) {
        this.isOpen = true
        this.$refs.container.style.height = this.$refs.content.clientHeight + 'px'
      }
    },
    close() {
      if(this.$refs.container) {
        this.isOpen = false
        this.$refs.container.style.height = '0px'
      }
    }
  }
}
</script>

<style>

</style>